<template>
  <div class="mobile container">
    <div class="row vertical-center">
      <div class="col-12 center">
        <h1>{{ $t("orientation.caption") }}</h1>
        <p>{{ $t("orientation.message") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import simulation from "../modules/Simulation"

export default {
  methods: {
    orientationHandler() {
      if (
        typeof window.orientation !== "undefined" &&
        /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
      ) {
        if (window.orientation == "90" || window.orientation == "-90") {
          if (simulation.mode === "staging") {
            this.$router.push("/generate")
          } else {
            this.$router.push("/vip")
          }
        }
      } else {
        if (simulation.mode === "staging") {
          this.$router.push("/generate")
        } else {
          this.$router.push("/vip")
        }
      }
    },
  },
  created() {
    let supportsOrientationChange = "onorientationchange" in window,
      orientationEvent = supportsOrientationChange
        ? "orientationchange"
        : "resize"
    window.addEventListener(orientationEvent, this.orientationHandler, false)
    this.orientationHandler()
  },
  destroyed() {
    let supportsOrientationChange = "onorientationchange" in window,
      orientationEvent = supportsOrientationChange
        ? "orientationchange"
        : "resize"
    window.removeEventListener(orientationEvent, this.orientationHandler, false)
  },
}
</script>
<style scoped>
h1 {
  background-color: #e5efef;
}
.btn {
  border-radius: 50% !important;
  height: 100px !important;
  width: 100px !important;
  font-size: 0px !important;
}

.btn-primary {
  border-color: white !important;
  background-color: white !important;
  max-width: 100px;
  max-height: 100px;
  background-image: url("../assets/web_button.png");
  background-repeat: no-repeat;
  background-size: cover;
}
@media screen and (max-width: 770px) and (orientation: landscape) {
  .btn-primary {
    border-color: white !important;
    background-color: white !important;
    max-width: 65px;
    max-height: 65px;
    background-image: url("../assets/web_button.png");
    background-repeat: no-repeat;
    background-size: cover;
  }

  .btn {
    height: 65px !important;
    width: 65px !important;
    font-size: 0px !important;
  }
}
@media screen and (max-width: 770px) and (orientation: portrait) {
  .btn-primary {
    border-color: white !important;
    background-color: white !important;
    max-width: 65px;
    max-height: 65px;
    background-image: url("../assets/web_button.png");
    background-repeat: no-repeat;
    background-size: cover;
  }

  .btn {
    height: 65px !important;
    width: 65px !important;
    font-size: 0px !important;
  }
}
</style>